export const PRODUCTS = [
  {
    id: "rose",
    lookupKey: "raystance_rose",
    name: "Rosé",
    edition: "No. 01",
    tagline: "Soft light, hard presence.",
    description:
      "Rimless blush lenses framed by gold cross accents. Soft light, hard presence.",
    price: 99.98,
    compareAt: 120,
    image: "/assets/product-rose.webp",
    alt: "RayStance Rosé — pink rimless sunglasses with gold cross accents on pink marble",
    materials: [
      "Rimless blush nylon lenses",
      "Gold-tone stainless hardware",
      "Signature cross accents, hand-set",
      "UV400 full-spectrum protection",
    ],
    sizing: { lens: "60 mm", bridge: "17 mm", temple: "140 mm" },
  },
  {
    id: "onyx",
    lookupKey: "raystance_onyx",
    name: "Onyx",
    edition: "No. 02",
    tagline: "The classic stance, cut deep.",
    description:
      "A bold black silhouette with smoke lenses. The classic stance, cut deep.",
    price: 99.98,
    compareAt: 120,
    image: "/assets/product-onyx.webp",
    alt: "RayStance Onyx — bold black sunglasses on travertine stone",
    materials: [
      "Hand-polished Italian acetate",
      "Smoke CR-39 lenses",
      "Five-barrel stainless hinges",
      "UV400 polarized protection",
    ],
    sizing: { lens: "56 mm", bridge: "19 mm", temple: "145 mm" },
  },
  {
    id: "reign",
    lookupKey: "raystance_reign",
    name: "Reign",
    edition: "No. 03",
    tagline: "Made to be noticed.",
    description:
      "Violet rimless lenses crowned with pavé gold crosses. Made to be noticed.",
    price: 99.98,
    compareAt: 120,
    image: "/assets/product-reign.webp",
    alt: "RayStance Reign — purple rimless sunglasses with jewelled gold crosses",
    materials: [
      "Rimless violet gradient lenses",
      "Pavé gold cross hardware",
      "Gold-tone titanium core",
      "UV400 full-spectrum protection",
    ],
    sizing: { lens: "62 mm", bridge: "16 mm", temple: "140 mm" },
  },
  {
    id: "ember",
    lookupKey: "raystance_ember",
    name: "Ember",
    edition: "No. 04",
    tagline: "Carry your own light.",
    description:
      "Black frames burning with amber lenses. For those who carry their own light.",
    price: 99.98,
    compareAt: 120,
    image: "/assets/product-ember.webp",
    alt: "RayStance Ember — black sunglasses with orange lenses on concrete",
    materials: [
      "Matte black acetate frame",
      "Amber CR-39 lenses",
      "Anti-glare inner coating",
      "UV400 full-spectrum protection",
    ],
    sizing: { lens: "57 mm", bridge: "18 mm", temple: "145 mm" },
  },
  {
    id: "halo",
    lookupKey: "raystance_halo",
    name: "Halo",
    edition: "No. 05",
    tagline: "Light, framed in gold.",
    description:
      "Crystal-clear rimless lenses crowned with gold cross accents. For those who carry light into every room.",
    price: 99.98,
    compareAt: 120,
    image: "/assets/look-1.jpg",
    alt: "RayStance Halo — clear rimless frame with gold cross accents, front view",
    materials: [
      "Rimless crystal-clear lenses",
      "Gold-tone cross hardware, hand-set",
      "Gold-tone titanium core",
      "UV400 full-spectrum protection",
    ],
    sizing: { lens: "61 mm", bridge: "16 mm", temple: "140 mm" },
  },
];

export const IN_THE_BOX = [
  "RayStance signature hard case",
  "Microfiber polishing cloth",
  "Certificate of authenticity",
];
